import {
    GET_CONSIGNMENT_DETAILS_SUCCESS,
    GET_CONSIGNMENT_DETAILS_FAILURE,
    USAGE_ATTACHMENT_UPLOAD_FAILURE,
    DELETE_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_ATTACHMENT_REQUEST_FAILURE,
    GET_IMAGE_PO_PREVIEW_SUCCESS,
    GET_IMAGE_PO_PREVIEW_FAILURE,
    setPOTissueImageDetails,
    setPONonTissueImageDetails,
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    VALIDATE_PRODUCT_DETAILS_SUCCESS,
} from '../actions';
import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { setMyCaseRef } from 'src/utils/util';

const usageAttachmentUploadEndpoint = () =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/attachment`;

const deleteAttachmentEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/removeAttachment?fileName=${fileName}`;

const getImagePoPreviewEndpoint = (fileName) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/attachment?attachmentName=${fileName}`;

const usageAttachmentUploadFunc = async (obj) => {
    try {
        const response = await axios.post(usageAttachmentUploadEndpoint(), obj);

        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

const deleteAttachmentFunc = async (obj) => {
    try {
        const response = await axios.delete(
            deleteAttachmentEndpoint(obj.fileName),
            obj
        );
        return response ? response : {};
    } catch (error) {
        return {};
    }
};
const getImagePoPreviewFunc = async (obj) => {
    try {
        const response = await axios.get(
            getImagePoPreviewEndpoint(obj.fileName)
        );
        return response ? response : {};
    } catch (error) {
        return {};
    }
};
const validateProductDetailsEndpoint = () =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/validateproductdetails`;

const validateProductDetailsFunc = async (obj) => {
    try {
        const response = await axios.post(
            validateProductDetailsEndpoint(),
            obj
        );
        return response ? response.data : {};
    } catch (error) {
        return 'error';
    }
};

export function* validateProductDetailsInBillingSaga(action) {
    const response = yield validateProductDetailsFunc(action.payload.reqBody);
    if (response !== 'error') {
        const validatedProducts = response.products ? response.products : [];
        const isForReplen = action.payload.isForReplen;
        const isForPriceOverride = action.payload.isForPriceOverride;

        // if (action.payload.isForReplen) {
        //     const itemTableData = yield select(
        //         (state) => state.reportUsageRootReducer.itemTableData
        //     );
        //     const patientDetails = yield select(
        //         (state) => state.reportUsageRootReducer.patientDetails
        //     );
        //     const validatedItemTableData = getValidatedItemTableData(
        //         itemTableData,
        //         validatedProducts
        //     );
        //     if (
        //         checkIfValidProductsInRecordScreen(
        //             validatedProducts,
        //             validatedItemTableData,
        //             patientDetails
        //         )
        //     ) {
        //         const replenItems =
        //             validatedItemTableData &&
        //             getReplenNonTissueItems(validatedItemTableData);
        //         if (replenItems?.length > 0) {
        //             yield* validateReplenProductsSaga(
        //                 validateReplenProducts(
        //                     replenItems.map((x) => x.cfn).toString()
        //                 )
        //             );
        //         }
        //     }
        // }
        yield put({
            type: VALIDATE_PRODUCT_DETAILS_SUCCESS,
            payload: {
                validItems: validatedProducts,
                productsValidated: true,
                isForReplen: isForReplen,
                isForPriceOverride: isForPriceOverride,
            },
        });
    } else {
        yield put({
            type: VALIDATE_PRODUCT_DETAILS_FAILURE,
            payload: {
                validItems: [],
                productsValidated: false,
            },
        });
    }
}

export function* getConsignmentDetails() {
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    //url += `/order/consignment?${params}`;
    url += '/order/generateMyCaseRef';
    try {
        const result = yield axios.get(url).then((response) => response.data);
        setMyCaseRef(result?.myCaseRef);
        yield put({
            type: GET_CONSIGNMENT_DETAILS_SUCCESS,
            myCaseRef: result.myCaseRef,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            // loadAll: value?.isLoadAll,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: {}
        });
        yield put({
            type: GET_CONSIGNMENT_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export const getAttachmentPromise = (attachmentObj, myCaseRef, salesOrg) => {
    const formData = new FormData();
    formData.append('poUploadedFile', attachmentObj, attachmentObj.name);
    formData.append('myCaseRef', myCaseRef);
    formData.append('salesOrg', salesOrg);
    return usageAttachmentUploadFunc(formData);
};

export function* usageAttachmentUploadSaga(action) {
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.consignmentDetailsReducer?.poTissueImageDetails,
            existingNonTissueImages:
                state.consignmentDetailsReducer?.poNonTissueImageDetails,
        })
    );
    try {
        const promiseArray = [];
        const { files, tissue, nonTissue, myCaseRef } = action.payload;
        [...(files || [])].forEach((file) => {
            if (tissue && nonTissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030'),
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            } else if (tissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030')
                );
            } else {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            }
        });

        const responses = yield Promise.all(promiseArray);
        const tissueFiles = [];
        const nonTissueFiles = [];
        responses.forEach((response) => {
            if (response?.fileName?.includes('_S030_')) {
                tissueFiles.push(response.fileName);
            } else if (response?.fileName?.includes('_S002_')) {
                nonTissueFiles.push(response.fileName);
            }
        });

        if (nonTissueFiles.length > 0) {
            yield put(
                setPONonTissueImageDetails(
                    existingNonTissueImages
                        ? `${existingNonTissueImages},${nonTissueFiles.join()}`
                        : nonTissueFiles.join()
                )
            );
            // yield put({
            //     type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
            //     payload: existingNonTissueImages
            //         ? `${existingNonTissueImages},${nonTissueFiles.join()}`
            //         : nonTissueFiles.join(),
            // });
        }

        if (tissueFiles.length > 0) {
            yield put(
                setPOTissueImageDetails(
                    existingTissueImages
                        ? `${existingTissueImages},${tissueFiles.join()}`
                        : tissueFiles.join()
                )
            );
            // yield put({
            //     type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
            //     payload: existingTissueImages
            //         ? `${existingTissueImages},${tissueFiles.join()}`
            //         : tissueFiles.join(),
            // });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: usageAttachmentUploadEndpoint(),
            requestPayload: action.payload
        });
        yield put({
            type: USAGE_ATTACHMENT_UPLOAD_FAILURE,
            payload: {},
        });
    }
}

export function* deleteAttachmentSaga(action) {
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.consignmentDetailsReducer?.poTissueImageDetails?.split(
                    ','
                ),
            existingNonTissueImages:
                state.consignmentDetailsReducer?.poNonTissueImageDetails?.split(
                    ','
                ),
        })
    );
    try {
        const response = yield deleteAttachmentFunc(action.payload);
        if (response.status) {
            const { fileName, isTissue } = action.payload;

            if (isTissue) {
                const deletedImageIndex = existingTissueImages.findIndex(
                    (extImg) => extImg === fileName
                );
                existingTissueImages.splice(deletedImageIndex, 1);
            } else {
                const deletedImageIndex = existingNonTissueImages.findIndex(
                    (exntImg) => exntImg === fileName
                );
                existingNonTissueImages.splice(deletedImageIndex, 1);
            }
            yield put({
                type: DELETE_ATTACHMENT_REQUEST_SUCCESS,
                payload: {
                    isTissue,
                    imagesToBeUpdated: isTissue
                        ? existingTissueImages.join()
                        : existingNonTissueImages.join(),
                },
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: deleteAttachmentEndpoint(action.payload.fileName),
            requestPayload: action.payload
        });
        yield put({
            type: DELETE_ATTACHMENT_REQUEST_FAILURE,
            payload: {},
        });
    }
}
export function* getImagePoPreviewSaga(action) {
    try {
        const response = yield getImagePoPreviewFunc(action.payload);
        if (response.status) {
            yield put({
                type: GET_IMAGE_PO_PREVIEW_SUCCESS,
                payload: response.data.attachment,
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getImagePoPreviewEndpoint(action.payload.fileName),
            requestPayload: action.payload
        });
        yield put({
            type: GET_IMAGE_PO_PREVIEW_FAILURE,
            payload: {},
        });
    }
}
